/* import __COLOCATED_TEMPLATE__ from './sync-conversation-history.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type AppService from 'embercom/services/app-service';
import type { PulseAccordion } from 'glint/pulse';
import type Attribute from 'embercom/models/attribute';
import { type default as PredicateGroup } from 'predicates/models/predicate-group';
import { type default as Predicate } from 'predicates/models/predicate';

interface Args {
  accordion: PulseAccordion;
  closeAccordion?: () => void;
  isSyncEnabled?: boolean;
  updateSyncToggle: () => void;
  predicateGroup?: PredicateGroup;
  ticketFields?: Attribute[];
  onUpdatePredicates: (predicates: Predicate[]) => void;
  selectedSyncOption?: string;
  onSyncOptionChange?: (value: string) => void;
}

interface Signature {
  Args: Args;
}

export default class SyncConversationHistory extends Component<Signature> {
  @service declare appService: AppService;

  get selectedSyncOption(): string {
    return this.args.selectedSyncOption || 'sync-all';
  }

  get title(): string {
    return (
      this.appService.mainStandalonePlatform.componentData['conversation-ingestion']
        ?.syncHistoryTitle ?? ''
    );
  }

  get isIntegrationConnected() {
    return this.appService.mainStandalonePlatform.isConnected;
  }

  get syncHistoryLabel(): string {
    return (
      this.appService.mainStandalonePlatform.componentData['conversation-ingestion']
        ?.syncTicketHistoryLabel ?? ''
    );
  }

  @action
  onSyncOptionChange(value: string): void {
    this.args.onSyncOptionChange?.(value);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Common::ConversationIngestion::SyncConversationHistory': typeof SyncConversationHistory;
  }
}
